import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';
document.addEventListener('DOMContentLoaded', function () {
    const aboutUsCertSections = document.querySelectorAll('.js-section-about-us-cert-block');

    aboutUsCertSections.forEach((section) => {
        new Swiper('.js-section-about-us-cert-block-certificates', {
            modules: [Autoplay, Pagination],
            loop: false,
            autoplay: {
                delay: 6000,
            },
            slidesPerView: 1,
            spaceBetween: 60,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                }
            }
        });
    });
});